export const PREMIUM_URL = 'https://app.almacenesdigitales.cl/suscripciones/premium';

export function openExternalLink(url: string): void {
  if (window.electronAPI?.openExternal) {
    window.electronAPI.openExternal(url);
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}

export function goToPremium(): void {
  openExternalLink(PREMIUM_URL);
}
